<template>
  <div>
    <TitlePage :title="$t('blacklist')"></TitlePage>

    <v-form @submit.prevent="save()" class="bb-gray pb-5" ref="form_create" v-model="check">
      <v-layout wrap>

        <template v-if="getUser.super_admin">
          <v-col md12 class="pl-4 pr-4">
            <CenterAutocomplete @message="setCenterId" ></CenterAutocomplete>
          </v-col>
        </template>


        <v-flex md12 class="pl-4 pr-4">
          <v-autocomplete
              v-model="customerToAdd"
              :items="searchResults"
              :loading="isLoading"
              :search-input.sync="search"
              hide-no-data
              hide-selected
              item-text="desc"
              item-value="_id"
              :label="$t('customer')"
              :placeholder="$t('startTypingToSearch')"
              return-object
              @change="setResultCustomer()"
              chips
              deletable-chips
              :hint="(searchResults.length === 0 && showHint) ? $t('noResults'):''"
          ></v-autocomplete>
        </v-flex>

        <template v-if="customerToAdd._id">
          <CustomerStats :user-id="customerToAdd._id" />
        </template>


        <v-flex md12 class="pt-10 d-flex">
          <v-divider class="marg-title"></v-divider>
        </v-flex>

        <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
          <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
            <v-icon left>mdi-keyboard-backspace</v-icon>
            {{ $t('back') }}
          </v-btn>
          <v-btn elevation="2" color="primary" class="ml-auto" type="submit">
            {{ $t('save') }}
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-flex>

      </v-layout>

    </v-form>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import CenterAutocomplete from "@/components/admin/CenterAutocomplete.vue";
import CustomerStats from "@/components/customers/CustomerStats.vue";

export default {
  name: "CreateClosure",
  components: {CustomerStats, CenterAutocomplete, TitlePage},
  data() {
    return {
      customerToAdd: {},
      searchResults: [],
      isLoading: false,
      search: '',
      showHint: '',
      item: {
        user_id: null,
        center_id: null,
        approved: null,
        status: null, // to_be_approved - active - canceled
        created_at: new Date(),
      },
      check: true,
    };
  },
  async created(){
    this.item.approved = !!(this.getUser.super_admin)
    this.item.center_id = (this.getUser.super_admin) ? null : this.getUser.center_id
    this.item.status = (this.getUser.super_admin) ? 'active':'to_be_approved'
  },
  computed: {
    ...mapGetters({
      'getEndpoint': 'settings/getEndpoint',
      'getUser': 'user/getUser',
    }),
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'storeItem': 'blacklists/store',
      'searchMyUsers': 'customers/searchMyUsers'
    }),
    setResultCustomer() {
      if(this.customerToAdd && this.customerToAdd._id){
        this.item.user_id = JSON.parse(JSON.stringify(this.customerToAdd._id))
      }else {
        this.searchResults = []
        this.item.user_id = ''
      }
    },
    async setCenterId(id) {
      this.item.center_id = id
      this.searchResults = []
      this.item.user_id = ''
    },
    async save(){

      this.$refs.form_create.validate()
      if(!this.check){
        return
      }

      if(!this.item.user_id){
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Errore: Selezionare un utente'
        })
        this.setLoading(false);
        return false
      }

      if(!this.item.center_id){
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Errore: Selezionare un centro sportivo'
        })
        this.setLoading(false);
        return false
      }

      await this.setLoading(true);
      let result = await this.storeItem(this.item)
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('createSuccess')
        })

        await this.$router.push('/blacklists/')

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }
    },

  },
  mounted() {

  },

  watch: {
    search (val,oldVal) {

      if(val == null || val === "" || val.length <= 2) return;
      if(this.isLoading) return

      this.isLoading = true
      this.showHint = false

      setTimeout(()=> {

        this.searchResults = []

        this.searchMyUsers({search: this.search, center_id: this.item.center_id}).then(result => {

          if(result.length > 0){
            result.map(x => this.searchResults.push({
              'desc': `${x.name} ${x.surname} - ${x.email} - ${x.phone}`,
              '_id': x._id
            }))
          }

          this.showHint = true

          this.isLoading = false
        })

      }, 1500);
    },
  },

}
</script>

<style scoped>

</style>